export default "__VITE_ASSET__DFB$sTkc__"